import React, { useEffect, useState } from "react";
import { LocationOn } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const toRadians = (degrees) => degrees * (Math.PI / 180);

const haversineDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371e3; // Radius of the Earth in meters
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = (R * c) / 1000; // Distance in meters
  return distance;
};

const DistanceDisplay = ({ lat1, lng1, lat2, lng2 }) => {
  const [distance, setDistance] = useState(null);

  useEffect(() => {
    if (lat1 && lng1 && lat2 && lng2) {
      const dist = haversineDistance(
        parseFloat(lat1),
        parseFloat(lng1),
        parseFloat(lat2),
        parseFloat(lng2)
      );
      setDistance(dist);
    }
  }, [lat1, lng1, lat2, lng2]);

  return (
    <Box display="flex" alignItems="center">
      {(distance !== null&&distance<400) && (
        <>
          <LocationOn fontSize="small" color="secondary" sx={{ marginBottom: "3px"  }}/>

          <Typography  sx={{ fontSize:"14px",marginLeft: "1px" }}>
            {distance.toFixed(2)} km
          </Typography>
        </>
      )}
    </Box>
  );
};

export default DistanceDisplay;
